import type { TranslationKeys } from '../localeType';

export const itIT: TranslationKeys = {
  // All Pages
  addAccessories: 'Aggiungere accessori',
  all: 'Tutti',
  checkAll: 'Seleziona tutto',
  anyFloristFounded: 'Nessun fiorista trovato',
  backToOrderList: 'Indietro',
  cancel: 'Cancellare',
  catalog: 'Catalogo',
  catalogAbroad: 'Catalogo prodotti esteri',
  closed: 'Chiuso',
  communications: 'Comunicazione',
  date: 'Data',
  download: 'Scaricare',
  downloadLabel: `Scarica etichetta`,
  endDate: 'Data di fine',
  goToOrders: 'Accedi ai tuoi ordini',
  goToOrder: `Accedi all'ordine`,
  history: 'Storia',
  hour: 'Ora',
  inProgress: 'In progresso',
  isModified: 'Modificato',
  isReady: 'Mazzo pronto',
  ITContact: 'Contatto Interflora',
  loginAs: 'Accesso effettuato come',
  modify: 'Modifica',
  new: 'Nuovo',
  noDocuments: 'Nessun documento trovato con questi filtri:',
  noOrderInTab: 'Nessun ordine per questo tab',
  noOrdersFound: 'Nessun ordine trovato',
  nothingFound: `Non abbiamo trovato nulla`,
  open: 'Aperto',
  orderDefault: 'Ordine',
  orders: 'Ordini',
  partner: 'Siti partner',
  price: 'Prezzo',
  startDate: 'Data di inizio',
  suspendedFlorist: 'Fiorista non attivo',
  to: 'a',
  and: 'e',
  today: 'Oggi',
  unknown: 'Sconosciuto',
  validate: 'Convalidare',
  save: 'Salva',
  view: 'Vista',
  close: 'Chiudi',
  actionImpossible: 'Non disponibile',
  listView: 'Visualizza elenco',
  listViewTooltip: "Questo pulsante consente di visualizzare l'elenco",
  mapView: 'Visualizza mappa',
  mapViewTooltip: 'Questo pulsante consente di visualizzare la mappa',
  viewOnMap: 'Vedi sulla mappa',
  true: 'Sì',
  false: 'No',
  delete: 'Elimina',
  warning: 'Attenzione',
  courierDeliveryOrderWarning: 'Stai agendo su un ordine inizialmente previsto per la consegna tramite corriere!',
  putOrderInProgress: 'Attivazione dello stato In corso',
  removeOrderInProgress: 'Disattivazione dello stato In corso',
  actionUnavailable: 'Azione impossibile',

  print: {
    title: 'Stampa i nuovi ordini',
    titleQuick: 'Stampa veloce',
    printed: 'Stampato',
    printTooltip: `Questo pulsante consente di stampare i documenti d'ordine che non sono ancora stati stampati`,
    printedError: 'Si è verificato un errore, riprova più tardi.',
    printedErrorMessage: 'Alcuni ordini non possono essere stampati.',
    partiallyPrinted: 'Alcune fatture non hanno potuto essere stampate.',
    nothingToPrint: 'Nessuna fattura da stampare.',
    markAsPrint: `L'ordine è stato contrassegnato come stampato.`,
    markAsPrintPlural: 'Gli ordini sono stati contrassegnati come stampati.',
    popup: {
      title: 'Contrassegnare come stampato?',
      titlePlural: 'Contrassegnare come stampati?',
      validate: 'Contrassegna come stampato',
      validatePlural: 'Contrassegna come stampati',
      cancel: 'Non contrassegnare',
      textQuickPrint: `Hai utilizzato la stampa veloce. Vuoi contrassegnare questi ordini come Stampati per evitare una ristampa tramite la stampa veloce?`,
      textMultiSelect: `Hai richiesto la stampa di più ordini. Vuoi contrassegnarli come Stampati per evitare una ristampa tramite la stampa veloce?`,
      textSinglePrint: `Vuoi contrassegnare l'ordine di cui hai appena visualizzato il documento come Stampato per evitare una ristampa tramite la stampa veloce?`,
    },
  },

  markAsPrint: {
    validMarkAsPrint: 'Le commandes sono state contrassegnate come stampate.',
    validUnmarkAsPrint: 'Le commandes sono state contrassegnate come non stampate.',
    warning: 'Alcune commandes non hanno potuto cambiare di stato',
    undoMarkAsPrint: 'Rimuovere lo stato Stampato',
    undoUnmarkAsPrint: 'Ripristinare lo stato Stampato',
  },

  // Homepage
  message: {
    welcome: 'Benvenuto, {name} \ud83c\udf3b',
  },
  ordersHome: {
    today: 'Ordini per oggi',
    tomorrow: 'Ordini per domani',
    later: 'Ordini per dopo',
    late: 'Ordini in ritardo',
  },
  orderHome: {
    today: 'Ordine per oggi',
    tomorrow: 'Ordine per domani',
    later: 'Order per dopo',
    late: 'Ordine in ritardo',
  },
  linkNewsLabel: 'Vedi nuove comunicazioni',
  seeMore: 'Vedi di più',
  seeLess: 'Vedere meno',
  seeHistory: `Vedi storico`,
  NoNotification: 'Nessuna notifica',
  explanation: {
    title: 'Iris introduzione',
    content: `Benvenuti nella vostra nuova piattaforma per fioristi.
Vogliamo ricordarvi che questa non è la versione finale, il nostro lavoro è ancora in corso. 
In questa fase, il vostro feedback è fondamentale.
Vogliamo ringraziarvi in anticipo per la vostra comprensione e pazienza.`,
  },
  newCollectionHome: 'La collezione del momento',

  // Nav
  nav: {
    admin: 'Il mio account',
    contact: 'Contatto',
    deliveries: 'Consegne',
    history: 'Storico',
    home: 'Home',
    internalUser: 'Utente interno',
    orders: 'Ordini',
    page: 'La mia pagina',
    QrCode: `Convalida dell'ordine`,
    signOut: 'Esci',
    transmissions: 'Transmissioni',
    faq: 'Domande Frequenti Fioristi',
    xlFlorist: 'Fiorista XL',
  },

  // Orders
  details: {
    download: 'Scaricare PDF',
    delivered: 'Consegnato',
    absent: 'Assente',
    reassign: 'Riassegna',
    additional: 'Informazioni aggiuntive',
    accept: 'Accetta',
    refuse: 'Rifiuta',
    assignToCourier: 'Assegnazione a un corriere',
    cancel: 'Annulla ordine',
    customerErrorMessage: `Impossibile visualizzare il documento d’ordine`,
    cancelDelivery: `Annulla la consegna`,
    recipient: {
      title: 'Destinatario e dettagli di consegna',
      label: {
        additionalStreetInfo: 'Complemento indirizzo',
        address: 'Indirizzo',
        colivex: 'Consegna su tomba',
        companyName: 'Località di consegna...',
        contactName: 'Nome del contatto',
        country: 'Nazione',
        deceasedName: 'Nome del defunto',
        deliveryDate: 'Data di consegna',
        deliveryLocation: 'Località di consegna...',
        deliveryMoment: 'Momento di consegna',
        deliveryTime: 'Orario di consegna',
        event: 'Evento',
        infos: 'Aggiungi info',
        instructions: 'Istruzioni',
        name: 'Nome',
        phone: 'Numero di telefono',
        postalCode: 'Codice Postale',
        prelimeryAgreement: 'Accordi precedenti', //not used in Italy
        region: 'Provincia',
        town: 'Città',
      },
    },
    order: {
      title: 'Dettagli ordine',
      label: {
        legacyOrderId: 'Numero di ordine ISOWEB',
        orderStatus: `Stato dell'ordine`,
        orderDate: 'Data ordine',
        price: 'Prezzo',
        deliveryCost: 'Costo di consegna',
        trackingCode: `Codice di spedizione`,
      },
      status: {
        NEW_ORDER: 'Nuovo ordine',
        ASSIGNED: 'Assegnato',
        ACCEPTED: 'Accettato',
        REFUSED: 'Rifiutato',
        ASSIGNATION_NOT_POSSIBLE: 'Assegnazione non possibile',
        NOT_PRINTED: 'Non stampato',
        PRINTED: 'Stampato',
        IN_PROGRESS: 'In progresso',
        INTERNAL_COURRIER: 'Corriere interno',
        EXTERNAL_COURRIER: 'Corriere esterno',
        DELIVERED: 'Consegnato',
        ABSENT: 'Assente',
        CANCELLED: 'Cancellato',
        SENT: 'Inviato',
        REASSIGN: 'Riassegnato',
      },
      notes: {
        addNote: 'Aggiungi nota',
        addPhoto: 'Aggiungi una foto',
        anythingElse: 'Aggiungi la tua nota',
        create: 'Crea una nota',
        delivery: 'Consegna',
        deliveryChanges: 'Modifiche alla consegna?',
        deliveryDetail: 'Specifica i dettagli della consegna',
        emptyNoteList: `Non ci sono note`,
        emptyPhotos: `Non hai foto`,
        imageCategory: `Categoria immagine`,
        notValidatedNote: 'Impossibile aggiornare lo stato di questo ordine',
        product: 'Prodotto',
        title: 'Aggiungi note',
        titleAddNotes: 'Aggiungi note',
        titleSetAsDelivered: 'Convalida una consegna',
        confirmSetAsDelivered: 'Sei sicuro di voler contrassegnare i {count} ordini selezionati come consegnati?',
        validatedNote: 'La nota è stata creata',
        validatedOrderNote: `L'ordine è stato convalidato`,
        dragAndDrop: 'Trascina e rilascia la tua immagine qui',
        or: 'oppure',
        browseFiles: 'Sfoglia i file',
        uploadPhoto: 'Carica la foto',
        addPhotoOptionnal: 'Aggiungi una foto (opzionale)',
      },
      delivery: {
        inProgress: {
          status: `Stato della consegna:`,
          momentTitle: `Data e ora: `,
          moment: `{date} - Tra {hour} e {hourPlusOne}`,
          price: `Prezzo:`,
          from: `da`,
        },
        cancel: {
          title: `Annulla la consegna`,
          body: `Questa operazione annullerà il servizio di consegna esterno assegnato a questo ordine.`,
          bodyInternalDelivery: 'Questa operazione annullerà la consegna interna associata a questo ordine.',
          buttonSecondary: `Abbandona`,
          buttonPrimary: `Conferma`,
        },
      },
      modifications: {
        title: 'Modified order details',
        tooltip: 'Click for updates',
        modalTitle: 'Updates',
        noChanges: 'Cannot display order modifications',
        markAsRead: 'Mark as read',
      },
      invoicePrintedLabel: {
        yes: 'Stampata',
        no: 'Non stampata',
      },
      invoicePrintedTooltip: {
        yes: 'Questa fattura è stata stampata',
        no: 'Questa fattura non è ancora stata stampata',
      },
      recipientSmsStatus: {
        sent: {
          label: 'SMS inviato',
          fullLabel: 'SMS inviato',
          tooltip: 'È stato inviato un SMS di notifica al destinatario',
        },
        resent: {
          label: 'SMS rinviato',
          fullLabel: 'SMS rinviato',
          tooltip: `L'SMS di notifica è stato rinviato al destinatario`,
        },
        expired: {
          label: 'SMS scaduto',
          fullLabel: 'SMS scaduto',
          tooltip: `L'SMS di notifica è scaduto`,
        },
        validatedByPhone: {
          label: 'Validato per telefono',
          fullLabel: 'Validato per telefono',
          tooltip: 'Il fiorista ha validato la consegna tramite chiamata telefonica',
        },
        validatedBySms: {
          label: 'Validato via SMS',
          fullLabel: 'Validato via SMS',
          tooltip: 'Il destinatario ha validato la consegna tramite il link SMS',
        },
      },
      recipientSmsAction: {
        removeValidation: 'Rimuovi validazione',
        resendSms: 'Rinvia SMS',
        validateByPhone: 'Segna come validato per telefono',
      },
      recipientSmsActionHint: {
        temporaryUnavailable: `L'invio è temporaneamente non disponibile`,
        smsAlreadyResent: `L'SMS è già stato rinviato`,
      },
    },
    florist: {
      title: {
        executor: 'Fiorista esecutore',
        transmitter: 'Fiorista trasmittente',
      },
      label: {
        name: 'Nome',
        id: 'Identificatore',
        Phone: 'Numero di telefono',
        Email: 'Email',
        SecondEmail: 'Email',
      },
    },

    ribbon: {
      title: 'Nastro',
      text: 'Testo del nastro : ',
    },

    buyer: {
      title: 'Dettagli acquirente',
      label: {
        name: 'Nome',
        phone: 'Numero di telefono',
        email: 'Email',
      },
    },

    header: {
      productCode: 'Codice Prodotto',
      quantity: 'Quantità',
      size: 'Taglia',
      description: 'Descrizione',
      price: 'Prezzo',
      image: 'Immagine',
      composition: 'Composizione',
      moreProducts: 'Altri prodotti',
      accessory: 'Accessori',
    },
    message: {
      title: 'Biglietto',
      label: {
        message: 'Testo biglietto',
        signature: 'Firma',
      },
    },
    addInfo: 'Aggiungi note',
    additionalImages: 'Foto salvate',
    recipientNotes: {
      title: 'Note destinatario',
      cardTitle: 'Nota del destinatario',
      cardTitleModified: 'Nuova nota del destinatario',
      canBeLeft: "L'ordine può essere lasciato senza sorveglianza.",
      cannotBeLeft: "L'ordine non può essere lasciato senza sorveglianza.",
    },
  },

  // Transmissions
  transmission: {
    title: 'Trasmissione ordine',
    new: 'Nuova trasmissione:',
    locale: 'Nazionale',
    abroad: `Estero`,

    table: {
      no: 'No.',
      id: 'Numero ordine',
      product: 'Prodotto',
      recipient: 'Destinatario',
      town: 'Città',
      status: 'Stato',
      date: 'Data',
    },
    form: {
      deliveryAddressCemeteryWarning: `L'indirizzo di consegna sembra essere un cimitero, ma l'opzione 'Consegna sulla Tomba' non è selezionata. Desidera continuare?`,
      cemetery: 'cimitero',
      country: 'Nazione',
      mandatoryFields: 'Campi obbligatori',
      noProductsForCountry: 'Nessun prodotto trovato per questo paese',
      freePrice: {
        title: 'Prezzo libero',
        low: 'Prezzo libero troppo basso',
        entry: 'Inserisci come  prezzo libero',
        from: 'A scelta da ',
        integer: `i centesimi non sono accettati dal sistema internazionale`,
      },
      delivery: {
        additionalStreetInfo: 'Informazioni aggiuntive/Presso',
        address: 'Indirizzo',
        addressComplement: 'Informazioni aggiuntive',
        city: 'Città',
        cityPostalCode: 'Città o codice postale',
        deliveryInstructions: 'Istruzioni consegna',
        extra: 'Extra',
        feasible: `E possibile eseguire questo ordine!`,
        foreignAddress: `Poiché non è possibile verificare gli indirizzi esteri, si prega di inserire l'indirizzo più completo possibile`,
        guarantee: `E garantito in giornata`,
        isBillNeeded: `Serve una fattura`,
        isCeremony: `E per una cerimonia?`,
        no: 'No',
        notFeasible: 'Non è possibile eseguire questo ordine!',
        notFound: ' Indirizzo non trovato',
        place: 'Nome del posto',
        psm: 'Informazioni personalizzate sul prodotto',
        slot: 'Momento di consegna',
        streetName: 'Nome della via',
        streetNumber: 'Numero della via',
        title: 'Consegna',
        toGrave: 'Consegna sulla tomba',
        yes: 'Si',
        zipCode: 'Codice postale',
        errorAddressAndLocality: `L'indirizzo non corrisponde alla destinazione {locality} selezionata sopra`,
        date: {
          title: 'Data di consegna',
          today: `Oggi`,
          tomorrow: 'Domani',
          later: 'Dopo',
          selectedDate: 'Data selezionata: ',
        },
      },

      productDetail: 'Prodotto',
      selectSize: 'Seleziona taglia',
      orderType: {
        title: 'Tipo ordine',
        regular: 'Normale',
        funeral: 'Funerale',
      },

      contact: {
        additionalStreetInfo: 'Informazioni aggiuntive',
        address: 'Indirizzo',
        buyerTitle: 'Dettagli acquirente',
        city: 'Città',
        companyName: `Nome dell'azienda`,
        contactTitle: 'Dettagli contatto',
        deceased: 'Deceduto',
        email: 'E-mail',
        firstName: 'Nome',
        fiscalCode: 'Codice fiscale',
        lastName: 'Cognome',
        phone: 'Telefono',
        title: 'Destinatario',
        zipCode: 'Codice postale',
      },
      message: {
        title: 'Biglietto',
        message: 'Testo biglietto',
        signature: 'Firma',
      },
      accessory: {
        addAccessory: 'Aggiungi accessorio',
        addMoreAccessories: 'Aggiungi più accessori',
        changeAccessory: 'Modificare',
        label: 'Accessorio',
        noAccessory: 'Nessun accessorio selezionato',
        removeAccessory: 'Cancellare',
        select: 'Seleziona un accessorio',
        title: 'Accessorio',
        needRibbonText: 'Aggiungere un nastro?',
        ribbonText: 'Inserire il testo per il nastro',
      },
      summary: {
        title: 'Sommario: ',
        productTotal: 'Totale prodotto:',
        accessoriesTotal: 'Totale accessorio:',
        deliveryCost: 'Importo consegna:',
        total: 'Totale: ',
        transmissionFormComplete: 'Il modulo di trasmissione è completo',
        stepper: {
          productDetails: 'Dettagli del prodotto',
          deliveryAddress: 'Indirizzo di consegna',
          deliveryDate: 'Data di consegna',
          feasability: 'Fattibilità',
          recipientInfo: 'Informazioni sul destinatario',
          buyerInfo: 'Informazioni sull’acquirente',
          feasabilityOK: 'Ordine fattibile',
        },
      },
      assignation: {
        title: 'Assegnazione fiorista',
        select: `Seleziona il tipo di assegnazione`,
        zone1: 'Principale',
        zone2: 'Riserva',
        zone3: 'Big zone',
        displayZone3: 'Mostra la lista di',
        automatic: 'Automatico',
        manual: 'Manuale',
        floristNumber: 'Numero Fiorista',
        floristNumberError: `Il formato del numero di membro non è quello previsto`,
        floristNumberSupporting: 'Il numero di membro deve iniziare con 00',
        validationCode: 'Codice di convalida',
        mandatoryValidationCode: 'Codice di convalida obbligatorio per questo prodotto',
        table: {
          floristName: 'Nome fiorista',
          phone: 'Numero di telefono',
          distance: 'distanza',
          quality: 'Premio di qualità',
        },
      },
      color: {
        select: 'Seleziona il colore',
        nbOfFlowers: 'Numero di fiori',
        price: 'Prezzo',
      },
      psp: {
        title: 'Pagamento',
        paymentOK: 'Pagamento riuscito! Ora puoi procedere con la trasmissione.',
        paymentKO: 'Pagamento fallito',
        paymentLinkExprired: 'Il link di pagamento è scaduto. Generane uno nuovo selezionando il tipo di pagamento.',
        linkAlreadyExist:
          'Sembra che tu abbia già generato un link di pagamento con carta bancaria. Assicurati che il cliente non lo utilizzi di nuovo per evitare un doppio pagamento.',
        linkTime: 'Tempo rimanente prima della scadenza del link di pagamento: {time}',
        paymentDone: 'Pagamento effettuato, la trasmissione verrà inviata automaticamente',
        selectPayment: {
          title: 'Seleziona un tipo di pagamento',
          cash: 'Contanti',
          bankCard: 'Carta bancaria',
        },
        paymentLink: {
          title: 'Scegli come inviare il link di pagamento al cliente',
          otherTab: 'Apri in una nuova scheda',
          sms: 'Invia SMS',
          QrCode: 'Genera codice QR',
        },
        otherTab: {
          title: 'Link di pagamento in un’altra scheda',
          explaination:
            'La pagina di pagamento si apre in una nuova scheda per il cliente. Ti informeremo quando il pagamento sarà completato o scaduto, così potrai procedere.',
        },
        sms: {
          title: 'Link di pagamento via SMS',
          send: 'Invia SMS',
          explaination:
            'Un link di pagamento è stato inviato al cliente via SMS. Ti informeremo quando il pagamento sarà completato o scaduto, così potrai procedere.',
          smsSendError: `Si è verificato un errore durante l'invio dell'SMS`,
          smsSendImpossible: `L'invio dell'SMS è impossibile`,
          paymentLinkMessage:
            'Interflora ti ringrazia per la tua fiducia. Ecco il link per il pagamento del tuo ordine. ',
        },
        qrCode: {
          title: 'Link di pagamento tramite codice QR',
          explaination:
            'Il cliente può scansionare il codice QR per accedere al link di pagamento. Una volta completato o scaduto il pagamento, ti informeremo così potrai procedere con la trasmissione.',
        },
      },
      sended: 'Trasmissione inviata',
      notSended: `Errore invio Trasmissione`,
      emailNotValid: 'E-mail non valido. esempio: %{email}',
      phoneNotValid: `Telefono non valido`, //. esempio: %{phone}
    },
    quickCheck: {
      title: 'Verifica una destinazione nazionale',
      label: 'Seleziona una destinazione',
      notFeasible: 'Questa destinazione non è disponibile per l’inoltro.',
      feasible: `Questa destinazione è disponibile per l’inoltro. 
Fai clic su « Continua l'inoltro » per accedere al modulo.`,
      accessForm: `Continua l'inoltro`,
    },
  },

  // OrderList
  delivered: 'Consegnato',
  absent: 'Assente',
  seeDetails: 'Vedi dettagli',
  hideDetails: 'Nascondi dettagli',
  multiproducts: 'prodotti',
  order: {
    search: 'Cosa stai cercando?',
    searchTooltip: 'Questo pulsante consente di effettuare una ricerca degli ordini',
    loadingOrders: 'Caricamento ordini in corso...',
    quickActions: {
      absent: 'Destinatario assente',
      accept: 'Accetta',
      acceptAndPrint: 'Accetta e stampa',
      assignToCourier: 'Assegna al corriere',
      clear: 'Cancella scelta',
      delivered: 'Consegnato',
      reassign: 'Riassegna',
      refuse: 'Rifiuta',
      tooLate: 'Troppo tardi per accettare',
      downloadCSV: 'Scarica CSV',
      print: 'Stampa',
      noOrderSelected: 'Seleziona più ordini per eseguire azioni di gruppo',
      noOrderSelectedShort: 'Nessun ordine selezionato',
      openToolbar: 'Apri multi-selezione',
      closeToolbar: 'Annulla multi-selezione',
      ordersSelected: '{nbOrders} ordini selezionati',
      acceptAll: 'Accetta tutta la selezione',
      acceptAndPrintAll: 'Accetta e stampa',
      cancelDelivery: `Annulla la consegna`,
      feedback: {
        cancelDeliveryOK: `La consegna esterna è stata annullata con successo e l'ordine è stato spostato nella scheda degli ordini.`,
        cancelInternalDeliveryOK: `La consegna interna è stata annullata con successo e l'ordine è stato spostato nella scheda degli ordini.`,
        cancelDeliveryKO: `Impossibile annullare la consegna esterna.`,
        cancelInternalDeliveryKO: `Non è possibile annullare la consegna interna.`,
      },
    },
    title: 'Lista ordini',
    noStatusBanner: {
      mainText: `Ci sono {count} ordine con fascia oraria di consegna in scadenza che non ha ancora lo stato "Consegnato" o "Destinatario assente". | Ci sono {count} ordini con fascia oraria di consegna in scadenza che non hanno ancora lo stato "Consegnato" o "Destinatario assente".`,
      subText: `Dietro ogni ordine, qualcuno aspetta di sapere se i suoi fiori sono arrivati. Ricordati di aggiornarli!`,
    },
    table: {
      no: 'No.',
      deliveryDate: 'Data consegna',
      deliveryTime: 'Momento consegna',
      id: 'Numero ordine',
      product: 'Prodotto',
      price: 'Prezzo',
      town: 'Città',
      recipient: 'Destinatario',
      preparing: 'In preparazione',
      invoice: 'Stampa Ordine',
      actions: 'Azioni',
      deliveryService: 'Servizio di consegna',
      reason: 'Motivo',
      openDetail: 'Apri dettaglio',
      closeDetail: 'Chiudi dettaglio',
      deliveryDetails: 'Dettagli di consegna',
      address: 'Indirizzo',
      phone: 'Numero di telefono',
      goToOrderDetail: 'Vai alla pagina di dettaglio ordine',
      instructions: 'Istruzioni di consegna',
    },
    modal: {
      refuse: {
        title: 'Vuoi rifiutare questo ordine?',
        reason: {
          reason1: 'Prezzo è  troppo basso',
          reason2: 'Il mio negozio è chiuso',
          reason3: `Non posso consegnare`,
          reason4: `Non ho questo prodotto`,
        },
      },
      absent: {
        title: `Perché l'ordine non è stato consegnato?`,
        subtitle: `Perché l'ordine non è stato consegnato?`,
        reason: {
          DANOREP: 'Destinatario irraggiungibile',
          DADATEULT: 'Il destinatario ha modificato la data di consegna',
          DAREFUS: 'Il destinatario ha rifiutato l’ordine',
          DANOINFO: 'Informazioni mancanti per consegnare l’ordine',
        },
      },
      reassign: {
        title: 'Vuoi riassegnare questo ordine?',
        reason: {
          PCO: 'Colori obbligatori mancanti',
          PFO: 'Fiori obbligatori mancanti',
          PL: 'Nessun corriere disponibile',
          LL: 'Consegna troppo lontana',
          RT: 'Ricevuto troppo tardi',
          PAM: 'Niente più scorte in negozio',
        },
      },
      delivery: {
        title: 'Scegliere un servizio di consegna',
        intro: `Scegli un servizio di consegna per l'ordine <b>{orderId}</b>.`,
        introMultiOrders: 'Scegliete un servizio di consegna per i {count} ordini.',
        deliveryCost:
          'Costo {deliveryService}({serviceAmount}) - Spese di consegna({itfAmount}) = Esborso({totalPrice})',
        delay: 'Disponibile in {noticePeriod}',
        availableImmediately: 'Disponibile immediatamente',
        includedDeliveryPrice: 'Incluso nel pacchetto di consegna',
        serviceUnavailable: 'Servizio non disponibile',
        selectYourSlot: 'Scegliere lo slot',
        deliverOrder: "Consegna l'ordine {orderId}",
        deliveryInstructions: 'Qualsiasi cosa per facilitare la consegna',
        validated: `L'ordine {orderId} è stato inviato a {service} !Controllare lo stato di consegna nella scheda di consegna`,
        internalValidated: `L'ordine viene assegnato ad {username} e spostato nella scheda “Consegna”.`,
        internalMultipleOrdersValidated: `Gli ordini vengono assegnati a {username} e spostati nella scheda “Consegna”.`,
        errorOnValidation: `Impossibile creare la consegna per l'ordine {orderId}`,
        errorOnMultipleOrdersValidation: 'Impossibile creare la spedizione degli ordini.',
        dateTooFar: `La data di consegna proposta è troppo lontana. Ti invitiamo a riprovare tra qualche giorno.`,
      },
    },
    multiSelect: {
      delivered: {
        allDelivered:
          '{count} ordini sono stati contrassegnati come consegnati con successo. Ora sono stati spostati nella cronologia degli ordini.',
        someNotUpdated: 'Alcuni dei tuoi ordini non hanno potuto essere aggiornati.',
        noneUpdated: 'Nessuno degli ordini selezionati ha cambiato stato.',
      },
      accept: {
        all: '{count} ordini sono stati accettati con successo. Ora sono spostati nella scheda ordini.',
        someNotUpdated: 'Alcuni dei tuoi ordini non hanno potuto essere accettati.',
        noneUpdated: 'Nessuno degli ordini selezionati è stato accettato.',
        waiting: 'Elaborazione in corso, attendere prego...',
      },
    },
    floristToggle: {
      changeStateTooltip: "Cambia lo stato dell'ordine",
      backToInitial: 'Torna allo stato iniziale',
      initial: {
        label: 'Iniziale',
      },
      inProgress: {
        label: 'In corso',
      },
      ready: {
        label: 'Bouquet pronto',
        lockedHint: 'Disponibile solo 2 ore prima della fascia di consegna',
      },
    },
  },

  // pager
  pager: {
    itemsPerPage: '{counter} per pagina',
  },

  // My page
  myPage: {
    title: 'La mia pagina',
    calendarManagement: 'Gestione calendario',
    infoManagement: 'Info gestione',
    notFound: 'Florist information not found',
    accessories: {
      accessoriesAction: 'Disponibilità',
      accessoriesList: 'Lista accessori',
      anyAccessory: 'Nessun accessorio',
      title: 'Gestione accessori',
    },
    hours: {
      title: 'Orari apertura',
      changeOpeningHours: 'Cambia i tuoi orari apeertura',
      closeAllDayButton: 'Chiudi tutto il giorno',
      shopClosed: 'Il tuo negozio è chiuso questo giorno',
      openButton: 'Aperto',
      addBreak: 'Aggiungi una pausa',
      removeBreak: 'Rimuovi la pausa',
      saveButton: 'Salva',
      closingTime: 'Orari chiusura',
      openingTime: 'Orari apertura',
      breakEnd: 'Fine pausa',
      breakStart: 'Inizio pausa',
    },
    exceptions: {
      headerTitle: 'Le mie eccezioni',
      the: 'Le :',
      from: 'Da:',
      new: `Aggiungi un'eccezione`,
      next: 'Prossime eccezioni',
      any: `Nessuna eccezione`,
      title: 'Prossime eccezioni',
      to: 'A:',
    },
    calendar: {
      title: 'Panoramica mensile',
      weeklyCalendar: {
        calendarModified: 'Il tuo calendario è stato modificato con successo',
        clickToChange: 'Clicca per aprire o chiudere*',
        closed: 'Chiuso',
        closedAM: 'Chiuso al mattino',
        closedPM: 'Chiuso nel pomeriggio',
        editWeek: 'Modifica il tuo programma settimanale',
        open: 'Aperto tutto il giorno',
        openAM: 'Aperto al mattino',
        openPM: 'Aperto nel pomeriggio',
        title: 'Calendario settimanale',
      },
      massive: {
        title: 'Aggiungi eccezioni massive',
        years: 'Anni',
        months: 'Mesi',
        days: 'Giorni',
        morning: 'Mattina',
        afternoon: 'Pomeriggio',
        exceptionsSended: 'Eccezioni inviate con successo',
        exceptionsNotSended: `Le eccezioni non possono essere registrate`,
      },
    },
    quality: {
      bonus: 'Bonus qualità',
      note: 'Il tuo voto',
      noteMini: 'Voto minimo',
      noteMaxi: 'Voto massimo',
      endPeriod: 'Fine validità',
      explainationTitleToMM: 'Il mio bonus qualità e Le mie riassegnazioni',
      explainationToMM: `Le sezioni « Il mio bonus qualità » e « Le mie riassegnazioni » non sono ancora disponibili su Iris.
Cliccando sui pulsanti corrispondenti, verrai reindirizzato a Mon magasin, dove sono accessibili.`,
      claims: {
        deliveryDate: 'Data',
        orderId: 'Numero Ordine',
        productCode: 'Prodotto',
        reason: 'Motivo',
        explainationTitleToMM: 'La pagina « Monitoraggio delle mie prestazioni » è in fase di costruzione',
        explainationToMM: 'Presto raccoglierà tutti i tuoi indicatori chiave in una dashboard completa e migliorata.',
      },
      title: {
        general: 'Generale',
        advertissement: 'Pubblicità / Promozione del Marchio',
        quality: 'Qualità del Servizio',
        availability: 'Disponibilità',
        tools: 'Strumenti',
      },
    },
    noStock: 'Attualmente non hai scorte',
    supplies: {
      title: 'Forniture',
      seeCart: 'Vedi e conferma il mio ordine',
      yourOrders: 'I tuoi ordini',
      emptyCart: 'Svuota il carrello',
      chooseSupplies: 'Scegli forniture',
      modifyChooseSupplies: 'Modifica e scegli le forniture',
      orderSupplies: 'Ordini di forniture',
      explainationTitleToMM: 'I tuoi ordini di forniture arriveranno presto su IRIS',
      explainationToMM: `Le sezioni « Ordini di forniture » e « I miei ordini di forniture » non sono ancora disponibili su IRIS.
Cliccando sui pulsanti corrispondenti, verrai reindirizzato a Mon magasin, dove potrai visualizzare e gestire i tuoi ordini di forniture.`,
      modal: {
        add: 'Aggiungi',
        freeArticles: 'Amministrativi (gratuiti)',
        paidArticles: 'Tecnici - Interflora (a pagamento)',
        productCode: 'Riferimento',
        image: 'Anteprima',
        label: 'Etichetta',
        VTACode: 'Codice IVA',
        price: 'Prezzo unitario',
        action: 'Azione',
      },
      panel: {
        cart: 'Il mio carrello',
        emptyCart: 'Il tuo carrello è vuoto',
        total: 'Totale : ',
        noOrders: 'Non hai ordini',
      },
    },
    contact: {
      mail: 'La tua email',
      mail2: 'La tua email secondaria',
      validationCode: 'Il tuo codice di convalida',
      address: 'Il tuo indirizzo',
      phone: 'Il tuo numero di telefone',
    },
    networkContact: {
      title: 'Il tuo referente Interflora',
      mail: 'La sua email',
      name: 'Il suo nome',
      phone: 'Il suo numero di telefono',
      phoneAppointment: 'Prendere un appuntamento telefonico',
    },
    exclusions: {
      title: 'Le mie esclusioni',
      list: 'La mia lista di esclusioni',
      empty: 'Non hai esclusioni',
    },
    claims: {
      title: 'Le mie segnalazioni',
      empty: 'Congratulazioni! Nessuna segnalazione registrata negli ultimi 12 mesi',
    },
    reassignations: {
      title: 'Le mie riassegnazioni',
      empty: 'Non hai riassegnazioni registrate negli ultimi 6 mesi',
    },
  },

  info: {
    addHolidaysKO: `Impossibile aggiungere questo periodo di chiusura`,
    addHolidaysOK: `Aggiunto il periodo di chiusura`,
    delHolidaysKO: `Impossibile cancellare questo periodo di chiusura`,
    delHolidaysOK: `Periodo chiuso cancellato`,
    documentKO: `Impossibile visualizzare il documento`,
    documentOK: `Il documento è stato aperto in un'altra finestra`,
    pending: `Domanda in corso`,
    documentPending: `Apertura del documento corrente, attendere`,
    editField: 'edit field',
    nophone: 'Per favore aggiungi un numero di telefono',
    nosecondMail: 'Per favore aggiungi un email',
    nopersonalCode: 'Per favore aggiungi un codice personale',
    statusKO: `Impossibile aggiornare lo stato`,
    statusOK: `Stato aggiornato`,
    updatePersonalCodeKO: 'Impossibile aggiornare il codice personale',
    updatePersonalCodeOK: 'Codice personale aggiornato',
    updatePhoneKO: 'Impossibile aggiornare il telefono',
    updatePhoneOK: 'Telefono aggiornato',
    updateSecondEmailKO: `Impossibile aggiornare l'e-mail`,
    updateSecondEmailOK: 'Email aggiornata',
    updateStockKO: `Impossibile aggiornare lo stock`,
    updateStockOK: 'Stock aggiornato',
    postSupplyOK: 'Ordine inviato',
    postSupplyKO: 'Ordine impossibile',
    duplicateHolidays: 'Una chiusura è già prevista per questo periodo.',
    photoUploadOK: 'Foto salvata',
    photoUploadKO: `Impossibile salvare la foto`,
    photoUploadTooBig: `La foto è troppo grande.
Si prega di caricare una foto inferiore a 5 MB.`,
    reassignOK: 'Ordine riassegnato, verrà reindirizzato alla lista degli ordini',
    reassignKO: 'Riassegnazione impossibile',
  },

  days: {
    initiale: { 1: 'L', 2: 'M', 3: 'M', 4: 'G', 5: 'V', 6: 'S', 0: 'D' },
    short: { 1: 'Lun', 2: 'Mar', 3: 'Mer', 4: 'Gio', 5: 'Ven', 6: 'Sab', 7: 'Dom' },
    0: 'Lunedì',
    1: 'Martedì',
    2: 'Mercoledì',
    3: 'Giovedì',
    4: 'Venerdì',
    5: 'Sabato',
    6: 'Domenica',
  },
  moment: {
    0: 'Mattina',
    1: 'Pomeriggio',
    2: 'Intera giornata',
    3: 'Sera',
    hour: {
      0: '9h-14h',
      1: '15h-20h',
      2: '9h-21h',
      3: '',
    },
  },
  openingMoment: {
    0: 'Chiuso tutto il giorno',
    1: 'Aperto la mattina',
    2: `Aperto nel pomeriggio`,
    3: 'Aperto tutto il giorno',
    4: 'Giorno festivo',
    5: 'Giorno festivo regionale',
    6: 'Giorno di apertura obbligatoria',
  },
  dropdown: {
    label: {
      accessory: 'Scegli accessorio',
      bouquet: 'Scegli il bouquet',
      city: 'Entra nella città',
      country: 'Scegli nazione',
      loginAs: 'Inserisci il codice del fiorista',
      mail: 'Inserisci e-mail',
      messageContent: 'Inserisci il messaggio',
      noteCategory: 'Categoria di note',
      photoCategory: 'Categoria della foto',
      occasion: 'Scegli occasione',
      receiveAnswerAt: 'Riceverete la risposta a',
      select: 'Scegli il motivo',
      selectCategory: 'Categoria di selezione',
      time: 'Scegli momento della giornata',
      type: 'Scegli tipo',
      year: `Scegli anno`,
      search: 'Cercare...',
      locality: 'Scegli la destinazione',
    },
    code: {
      ALL: 'Tutto',
      // OBJECT OF THE MESSAGE
      B2B: 'Ordini aziende B2B',
      CALL: 'Richiesta chiamata da team commerciale',
      CANCEL: `Voglio cancellaree l'ordine`,
      CLAIM: 'Reclami/controversie',
      HELP: ' Iris assistenza',
      INDEMNITY: 'Domanda sullo stato dei pagamenti',
      INFO: `Necessito informazioni per processare ordine`,
      QUALITY: 'Bonus qualità',
      SHOP1: 'Tuo negozio(disposizione/fine/nuovi dettagli contatto)',
      SHOP2: 'Tuo negozio (accessori/insegna)',
      SUPPLY: 'Fornisci ordine',

      // MOMENT
      0: 'Mattina',
      1: 'Pomeriggio',
      2: 'Intera giornata',
      AFTERNOON: 'Pomeriggio',
      DAY: 'Intera giornata',
      MORNING: 'Mattina',

      // EVENT
      BABY: 'Nascita',
      BIRTHDAY: 'Compleanno',
      CONGRATULATIONS: 'Congratulazioni',
      FUNERALS: 'Funerale',
      JUSTBECAUSE: 'Per piacere',
      OTHER: 'Altra ragione',
      WEDDING: 'Matrimonio',
      WELLSOON: 'Guarisci presto',

      // MAIL REASONS
      ADMIN: 'Domanda su amministrazione',
      HARDWARE: 'Domanda su problema al PC',
      INVOICEINCIDENT: '',
      ORDER: 'Domanda su un ordine',
      ORDERINCIDENT: '',
      ORDERMATERIAL: '',
      PARTNER: 'Domanda sulla mia partnership',
      SUGGESTION: '',

      // DOCUMENTS
      IT_DOC_ORDER_CART: 'Dettaglio carrello',
      IT_DOC_ORDER_RECEIVER: 'Stampa ordine',
      IT_DOC_ORDER_SENDER: 'Stampa ordine',
      IT_INVOICE_BALANCE: 'Saldo(2024)',
      IT_INVOICE_PURCHASE: 'Fattura Attiva(2024)',
      IT_INVOICE_VENDOR: 'Fattura Passiva(2024)',
      SP_INVOICE_COMMISSIONS: 'Fatture di acquisto commissione ordini trasmessi',
      SP_INVOICE_EXECUTIONS_RECTIFY: 'Note di credito ordini eseguiti',
      SP_INVOICE_EXECUTIONS: 'Fatture di acquisto ordini eseguiti',
      SP_INVOICE_EXTRACT: 'Saldo riepilogativo  mensile',
      SP_INVOICE_QUOTAS: 'Fatture di vendita quota mensile/ Note di credito',
      SP_INVOICE_MATERIAL: 'fattura materiale',
      SP_INVOICE_COMMISSIONS_RECTIFY: 'fattura di rettifica commissioni',
      SP_INVOICE_CSI_SALES: 'Facture (commandes exécutées)',
      SP_INVOICE_QUOTAS_RECTIFY: 'Quote di fatturazione rettificate',
      PT_SAFT: 'Saft',
    },
  },

  notification: {
    title: 'Notifica',
    label: {
      order: 'nuovo ordine',
      orderPlural: 'nuovi ordini',
      transmission: 'transmissione',
      transmissionPlural: 'transmissioni',
      review: 'Recensione',
      reviewPlural: 'Recensioni',
      modification: 'modifica',
      modificationPlural: 'modifiche',
      cancellation: 'cancellazione',
      cancellationPlural: 'cancellazioni',
      refused: 'ordine rifiutato',
      refusedPlural: 'ordini rifiutati',
      expired: 'ordine scaduto',
      expiredPlural: 'ordini scaduti',
    },
    message: {
      hideNotification: 'Nascondere la notifica',
      more: 'Espandi',
      orderPlural: 'Vedi lista ordini',
      transmissionPlural: 'Vedi lista trasmissioni',
      reviewPlural: 'Vedi recensioni',
      modificationPlural: 'Vedi lista ordini',
      cancellationPlural: 'Nascondere la notifica',
      refusedPlural: 'Nascondere la notifica',
      expiredPlural: 'Nascondere la notifica',
    },
    markAllAsRead: 'Segna tutto come letto',
  },

  mail: {
    from: 'Messaggio dal fiorista: ',
    subject: 'Soggetto: ',
    body: 'Messaggio: ',
    sended: 'Email inviata',
    notSended: `Errore invio email`,
  },

  billing: {
    notAllowed: 'Non sei autorizzato a vedere questa informazione',
    header: {
      id: 'Numero',
      date: 'Data',
      numberOfTransmission: 'Numero di trasmissioni',
      amount: 'Importo',
      type: 'Tipo',
      file: 'File',
    },
  },
  filter: {
    all: 'Tutto',
    today: 'Oggi',
    tomorrow: 'Domani',
    later: 'Ordini futuri',
    past: 'Ritardo',
    toPrepare: 'Ordini da eseguire',
    inDelivery: 'Consegna',
    absent: 'Assente',
    toAccept: 'Da accettare',
    inProgress: 'In preparazione',
    late: 'Ordini in ritardo',
    delivered: 'Consegnato',
    activity: 'La mia attività',
    financial: 'I miei compensi',
    profiles: 'I miei corrieri',
    activCourier: 'Corrieri attivi',
    inactivCourier: 'Corrieri inattivi',
    allCourier: 'Tutti i corrieri',
    legal: 'Documenti legali',
    manageStore: 'Gestisci il mio negozio',
    bonus: 'Premio di qualità',
    customer: `Documento d'ordine cliente`,
    executingForm: `Esecuzione del modulo d'ordine`,
    IT_DOC_ORDER_CART: 'Dettaglio carrello',
    IT_DOC_ORDER_RECEIVER: 'Stampa ordine',
    IT_DOC_ORDER_SENDER: 'Stampa ordine',
    IT_INVOICE_BALANCE: 'Saldo(2024)',
    IT_INVOICE_PURCHASE: 'Fattura Attiva(2024)',
    IT_INVOICE_VENDOR: 'Fattura Passiva(2024)',
    SP_INVOICE_COMMISSIONS: 'Fatture di acquisto commissione ordini trasmessi',
    SP_INVOICE_EXECUTIONS_RECTIFY: 'Note di credito ordini eseguiti',
    SP_INVOICE_EXECUTIONS: 'Fatture di acquisto ordini eseguiti',
    SP_INVOICE_EXTRACT: 'Saldo riepilogativo  mensile',
    SP_INVOICE_QUOTAS: 'Fatture di vendita quota mensile/ Note di credito',
    SP_INVOICE_MATERIAL: 'fattura materiale',
    SP_INVOICE_COMMISSIONS_RECTIFY: 'fattura di rettifica commissioni',
    SP_INVOICE_CSI_SALES: 'Fattura (ordini eseguiti)',
    SP_INVOICE_QUOTAS_RECTIFY: 'Quote di fatturazione rettificate',
    PT_SAFT: 'Saft',
  },

  size: {
    label: 'Seleziona taglia',
    0: 'Prezzo unico',
    1: 'Standard',
    2: 'Premium',
    3: 'Deluxe',
    4: 'Prezzo libero',
    Standard: 'Standard',
    Premium: 'Premium',
    Deluxe: 'Deluxe',
    one_size: 'Taglia unica',
    small: 'Standard',
    medium: 'Premium',
    large: 'Deluxe',
    null: 'Secondo il prezzo',
    Normal: 'Standard',
    Grande: 'Premium',
    Superior: 'Deluxe',
    Pequeño: '',
    Médio: '',
    Médium: 'Premium',
    Petit: 'Standard',
  },

  deliveryMode: {
    CEREMONY: 'Cerimonia',
    NO_ADDRESS: 'Nessun indirizzo',
    SELF: 'Per sé',
    STANDARD: 'Standard',
    TOMB: 'Tomba',
    FUNERAL_PLACE: 'Luogo del funeral',
    GRAVE: 'Tomba',
  },

  error: {
    floristUnknown: {
      title: 'Login sconosciuto',
      body: `L'account corrente non è valido: si prega di cliccare sul pulsante di logout e di scegliere un altro account.`,
      button: 'Logout',
    },
    noCountryCode: {
      title: 'Codice paese sconosciuto',
      body: 'Codice paese sconosciuto: cliccare sul pulsante di logout e scegliere un altro account',
      button: 'Logout',
    },
  },

  soon: {
    kpi: 'Prossimamente, trovate qui i vostri KPI aziendali',
    hourly: 'Prossimamente, trova qui i tuoi orari di apertura',
  },

  color: {
    blue: 'Blu',
    green: 'Verde',
    mixed: 'Colori misti',
    orange: 'Arrancione',
    pink: 'Rosa',
    purple: 'Violet',
    red: 'Rosso',
    silver: 'Argento',
    white: 'Bianco',
    yellow: 'Giallo',
  },
  QrCode: {
    200: `L'ordine è stato consegnato`,
    400: `Non è possibile impostare lo stato dell'ordine su consegnato`,
    500: 'Si è verificato un errore, contattare Interflora',
  },

  internalUser: {
    any: 'Nessun fiorista selezionato',
    backToAdmin: `Torna all'area dell'amministratore`,
    loggedIn: 'Sei connesso come',
    login: 'Login',
    needId: 'Devi essere collegato a un fiorista per vedere queste informazioni',
    placeholder: 'Inserisci il codice del fiorista',
    title: 'Accedi come',
  },

  // DELIVERY STATUSES
  deliveryStatus: {
    scheduled: 'Programmata',
    booked: 'Presa in carico',
    pending: 'Ricerca fattorino',
    picking: 'Consegnatore in viaggio',
    almost_picking: 'Consegnatario nelle vicinanze',
    waiting_at_pickup: 'In attesa del ritiro',
    delivering: 'In consegna',
    almost_delivering: 'Vicino al luogo di consegna',
    waiting_at_dropoff: 'In attesa della consegna',
    delivered: 'Consegnato',
    no_courier_available: 'Nessun corriere disponibile',
    cancelled: 'Consegna annullata',
  },

  calendarExceptionType: {
    CountryForceOpen: 'Apertura obbligatoria',
    CountryHolidays: `Festività del paese`,
    DefaultDates: 'Aperto',
    FloristCloseOnlyAfternoon: 'Chiuso solo il pomeriggio',
    FloristCloseOnlyMorning: `Chiuso solo la mattina`,
    FloristHoliday: 'Vacanze',
    FloristOpenOnlyAfternoon: 'Aperto solo pomeriggio',
    FloristOpenOnlyMorning: `Aperto solo la mattina`,
    FloristOpenWholeDay: 'Aperto',
    RegionalHoliday: 'Festa regionale',
  },

  month: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'Mag',
    6: 'Giu',
    7: 'lug',
    8: 'Ago',
    9: 'Set',
    10: 'Ott',
    11: 'Nov',
    12: 'Dec',
  },
  lastsMonth: 'Ultimi 12 mesi',
  kpi: {
    labelBestSeller: 'Numero di vendite',
    labelExecution: 'Importo delle esecuzioni',
    labelNPS: 'NPS',
    labelNumberOfRefusal: 'Numero di rifiuti',
    thisMonth: 'Questo mese',
    titleBestSeller: 'I vostri best seller',
    titleExecution: 'Le mie esecuzioni',
    tooltipExecution: `Numero di esecuzioni`,
    noDataPeriod: 'Nessun dato per questo periodo',
    month: {
      0: 'Jan',
      1: 'Feb',
      2: 'Mar',
      3: 'Apr',
      4: 'Mag',
      5: 'Giu',
      6: 'lug',
      7: 'Ago',
      8: 'Set',
      9: 'Ott',
      10: 'Nov',
      11: 'Dec',
    },
  },

  locality: {
    FR: 'France Métropolitaine',
    CORSE: 'Corse',
    DOMTOM: 'Drom-Com',
  },

  compensation: {
    explanation: '',
    title: 'La mia compensazione per ',
    fortnight: {
      1: 'Prima quindicina',
      2: 'Seconda quindicina',
    },
    login: {
      title: 'Accesso riservato',
      secretCode: 'Codice segreto:',
      placeholder: '12345',
      error: 'Codice segreto errato',
    },
    recette: {
      download: 'Download results of',
    },
  },

  capping: {
    title: 'Capacità di esecuzione',
    adjustCapping: 'Modifica il limite di capacità',
    daysBeforeEvent: `L'evento si svolge tra {count} giorno{plural}`,
    needToBeSuperior: `Durante questo periodo non è possibile ridurre il limite sotto {minCapping}. Si prega di modificare il valore.`,
    ordersLeft: `Mancano {ordersLeft} ordini al raggiungimento del limite! Potresti considerare di aumentare il limite massimo.`,
    noOrdersLeft: `Hai raggiunto la capacità massima di esecuzione. Potresti considerare di aumentare il limite massimo.`,
  },

  xlPage: {
    productsStock: {
      action: 'Azioni prodotti',
      list: 'Lista prodotti',
      anyProduct: 'Nessun prodotto',
      title: 'Gestione prodotti',
      selection: {
        flower: 'Fiori',
        gift: 'Regali',
      },
    },
  },

  internalCourier: {
    createNewCourier: 'Aggiungi un corriere',
    undefined: 'Non definito',
    list: {
      headerTable: {
        courierProfile: 'Fattorino',
        courierId: 'ID corriere',
        activationDate: 'Data di attivazione',
        deactivationDate: 'Data di disattivazione',
        actions: 'Azioni',
      },
      statusSrOnly: {
        active: 'Profilo corriere attivo',
        inactive: 'Profilo corriere inattivo',
      },
      toggleStatus: {
        active: 'Attiva profilo',
        inactive: 'Disattiva profilo',
      },
      edit: 'Modifica profilo',
      empty: {
        title: 'Non è stato ancora creato alcun profilo di corriere.',
        text: 'I profili dei corrieri ti consentono di assegnare gli ordini ai tuoi corrieri interni.',
      },
    },
    create: {
      couriersInformation: 'Informazioni del corriere',
      title: 'Crea un profilo corriere',
      name: 'Nome del corriere*',
      nameAlreadyExistMessage: 'Questo nome è già in uso. Aggiungi qualcosa (ad esempio un numero) per renderlo unico.',
      id: 'Identificatore di accesso del corriere',
      idExplaination:
        "L'identificatore consente a questo profilo di accedere a Iris. Viene creato automaticamente dal nome inserito e dalle informazioni del tuo negozio per essere unico.",
      profileCreated: 'Il corriere è stato creato.',
      profileNotCreated: 'Impossibile creare il corriere',
      password: {
        label: 'Password*',
        confirmLabel: 'Conferma password*',
        confirmNotMatch: 'I due campi non corrispondono.',
        rules: {
          uppercase: 'Una lettera maiuscola',
          lowercase: 'Una lettera minuscola',
          number: 'Un numero',
          minCaracters: 'Più di 10 caratteri',
          specialCaracters: "Un carattere speciale tra ? ! - _ & % {'@'}",
        },
      },
      status: {
        title: 'Lo stato del corriere',
        explanation: {
          activation: {
            default: `Il corriere sarà attivo dal giorno di attivazione selezionato.`,
            inactiv: 'Il corriere sarà inattivo.',
          },
          desactivation: {
            default: `Il corriere sarà inattivo dal giorno di disattivazione selezionato.`,
            notDefine: `Il corriere rimarrà attivo fino a quando non lo si disattiverà.`,
          },
          tomorrowTooltip: `La data di disattivazione non può essere precedente alla data di attivazione.`,
        },
      },
      date: {
        activationTitle: `Data di attivazione*`,
        desactivationTitle: 'Data di disattivazione*',
        today: `Oggi`,
        tomorrow: 'Domani',
        otherDate: 'Altra data',
        notDefine: 'Non definito',
        endDateBeforeStartDate: 'La data di disattivazione non può essere precedente alla data di attivazione.',
      },
      error: {
        someFieldsNeedCorrection:
          'Alcune informazioni devono essere corrette. Si prega di verificare i campi segnalati.',
        someFieldsAreMissing: 'Alcune informazioni sono mancanti. Si prega di verificare i campi segnalati.',
        fieldRequired: 'Questo campo è obbligatorio.',
        impossibleToCreate: 'Impossibile creare il profilo del corriere.',
      },
    },
    update: {
      title: 'Modifica un profilo corriere',
      profileUpdated: 'Il corriere è stato modificato.',
      selectedCourier: 'Il corriere selezionato',
      cancelButton: 'Mantenere la pianificazione',
      activationButton: 'Attivare',
      deactivationButton: 'Disattiva',
      password: {
        edit: 'Modifica la password',
        label: 'Nuova password*',
        closeWithoutSaving: 'Chiudi senza salvare',
      },
      error: {
        impossibleToUpdate: 'Impossibile aggiornare il profilo del corriere.',
      },
      guidingMessage: {
        activation: "Sembra che sia già stata programmata un'attivazione per questa mail!",
        deactivation: 'Sembra che per questa mail sia già stata programmata una disattivazione!',
        activationDate: 'Data di attivazione prevista:',
        deactivationDate: 'Data prevista per la disattivazione:',
        profileDeactivate: 'Il corriere è stato disattivato con successo',
        profileActivate: 'Il corriere è stato attivato con successo',
        disableActions:
          'Per modificare il periodo di attività o eliminare questo corriere, è necessario prima rimuovere gli ordini a lui associati.',
      },
      modalTitle: {
        deactivation: 'Disattivare il corriere',
        activation: 'Attivare il corriere',
      },
    },
    delete: {
      title: 'Elimina un profilo corriere',
      button: 'Elimina questo corriere',
      bodyTitle: 'Sei sicuro/a di voler eliminare definitivamente questo corriere?',
      profileDeleted: 'Il corriere è stato eliminato con successo.',
      error: {
        impossibleToUpdate: 'Impossibile eliminare il profilo del corriere',
        activeOrders:
          'Questo corriere ha ancora degli ordini attivi in corso. Annulla o riassegna questi ordini dalla scheda Consegna, quindi riprova.',
      },
    },
    deliveryTab: {
      isActiv: 'Interno',
      isInactiv: 'Corriere inattivo',
    },
    assignation: {
      title: 'Consegna interna',
      activeProfiles: '{n} profilo attivo il giorno della consegna',
      activeProfilesPlural: '{n} profili attivi il giorno della consegna',
      noActiveProfiles: 'Nessun corriere disponibile',
      goToInternalCourierList: 'Apri la gestione dei corrieri',
    },
    detail: 'Ordine gestito internamente',
  },
  onboarding: {
    title: 'Tutorial',
    checkLater: 'Ricorda più tardi',
    close: 'Chiudi',
    startGuide: 'Inizia',
    next: 'Avanti',
    finishGuide: 'Ho capito',
    readTime: 'Tempo stimato: {minutes} min',
    recipientConfirmation: {
      welcome: {
        title: 'Tutorial - Novità',
        description: [
          'Abbiamo aggiunto nuovi strumenti alla tua interfaccia per semplificarti la vita nel monitoraggio dei tuoi ordini e delle tue consegne. Lasciati guidare per scoprire come funzionano!',
          'Le novità:',
          '1. SMS al destinatario',
          '2. Foto alla consegna',
          '3. Miglioramenti della visualizzazione',
        ].join('\n'),
      },
      step1: {
        title: "Invio dell'SMS al destinatario",
        description: [
          'Il destinatario riceve automaticamente un SMS <strong>che gli chiede di confermare i suoi dati e la sua presenza nella data e nella fascia oraria richieste.</strong>',
          "Invio SMS: il giorno prima della consegna alle 18:00 oppure 30 min dopo l'acquisto per gli ordini effettuati in giornata.",
          '<br />',
          'Risparmia tempo: se il destinatario ha confermato, non serve più chiamarlo prima di partire per la consegna!',
          'Altrimenti, procedi con la consegna come fai oggi.',
        ].join('\n'),
      },
      step2: {
        title: "Stati dell'SMS",
        description: [
          "L'SMS può avere diversi stati:",
          '1- "Validato" via SMS - è tutto ok, l’icona diventa verde',
          'Una volta validato, il destinatario non può più modificare queste informazioni.',
          '2- "Validato" per telefono - Hai sentito il destinatario per telefono, convalida manualmente lo stato',
          `3- "Inviato" - l'SMS è stato inviato`,
          `4- "Rinviato" - rilancia l'invio di un SMS con un clic per dare al destinatario una seconda possibilità di confermare.`,
          '5- "Scaduto" - nessuna risposta 1 ora prima della fine della fascia oraria di consegna, il destinatario non può più aggiungere informazioni o convalidare -> procedi con la consegna come fai oggi',
        ].join('\n'),
      },
      step3: {
        title: 'Nuovo stato "Pronto"',
        description: [
          `Una volta terminata la preparazione del prodotto, imposta l'ordine su iris nello stato "Pronto": sei pronto per consegnarlo.`,
          'Nota: ',
          '- una volta impostato lo stato "Pronto", il destinatario non può più aggiungere informazioni',
          "- questo stato è disponibile il giorno della consegna, a partire da 2 ore prima dell'inizio della fascia oraria di consegna",
        ].join('\n'),
      },
      step4: {
        title: "Aggiornamenti delle informazioni dell'ordine",
        description: [
          "Se il destinatario aggiunge dei dettagli o se l'ordine viene modificato, compare l'icona «i» viola.",
          'Accedi con un clic alla cronologia delle modifiche di un ordine.',
          "Clicca sull'icona «i» dalla lista degli ordini per vedere cosa è cambiato e contrassegnare la modifica come vista.",
          'Queste informazioni restano consultabili in qualsiasi momento.',
        ].join('\n'),
      },
      step5: {
        title: 'Il destinatario accetta la consegna in sua assenza',
        description: [
          "Il destinatario può autorizzare il deposito dell'ordine in sua assenza, con eventuali informazioni aggiuntive. Es.: dal vicino, davanti alla porta, dietro il cancello a destra...",
          "Trovi queste informazioni nella pagina di dettaglio dell'ordine o tramite l'icona «i»",
          'In questo caso specifico, <strong>è richiesta una foto al momento della consegna, senza volti visibili. Ti tutela in caso di contestazione.</strong>',
        ].join('\n'),
      },
      step6: {
        title: 'Come scattare la foto?',
        description:
          "Quando confermi la consegna, compare una schermata. Ricordati di scorrere verso il basso con la barra laterale per far apparire l'opzione FOTO",
      },
      step7: {
        title: 'Monitoraggio delle stampe',
        description: "Dalla lista degli ordini, individua a colpo d'occhio se i tuoi ordini sono stati stampati.",
      },
      step8: {
        title: 'Colori di stato più visibili',
        description:
          'Il colore è stato rafforzato in alcune zone delle righe degli ordini per distinguere meglio gli stati, senza appesantire la lettura del resto della riga.',
      },
    },
  },
};
